import React from 'react';

function PasswordStrengthIndicator({ password }) {
  const getPasswordStrength = (pwd) => {
    if (!pwd) return { strength: 0, label: '', color: '' };
    
    let strength = 0;
    let checks = {
      length: pwd.length >= 8,
      lowercase: /[a-z]/.test(pwd),
      uppercase: /[A-Z]/.test(pwd),
      number: /[0-9]/.test(pwd),
      special: /[^A-Za-z0-9]/.test(pwd)
    };
    
    if (checks.length) strength++;
    if (checks.lowercase) strength++;
    if (checks.uppercase) strength++;
    if (checks.number) strength++;
    if (checks.special) strength++;
    
    const levels = [
      { label: 'Very Weak', color: '#dc3545' },
      { label: 'Weak', color: '#fd7e14' },
      { label: 'Fair', color: '#ffc107' },
      { label: 'Good', color: '#20c997' },
      { label: 'Strong', color: '#198754' },
      { label: 'Very Strong', color: '#0d6efd' }
    ];
    
    return {
      strength,
      percentage: (strength / 5) * 100,
      label: levels[Math.min(strength, 5)].label,
      color: levels[Math.min(strength, 5)].color,
      checks
    };
  };
  
  const strengthData = getPasswordStrength(password);
  
  if (!password) return null;
  
  return (
    <div className="password-strength-indicator">
      <div className="strength-bar-container">
        <div 
          className="strength-bar"
          style={{
            width: `${strengthData.percentage}%`,
            backgroundColor: strengthData.color,
            height: '4px',
            borderRadius: '2px',
            transition: 'all 0.3s ease'
          }}
        />
      </div>
      <div className="strength-info d-flex justify-content-between align-items-center mt-2">
        <small style={{ color: strengthData.color, fontWeight: 500 }}>
          {strengthData.label}
        </small>
        <div className="strength-checks d-flex gap-2">
          {strengthData.checks.length && (
            <i className={`bi ${strengthData.checks.length ? 'bi-check-circle-fill text-success' : 'bi-circle'}`} style={{ fontSize: '0.7rem' }}></i>
          )}
          {strengthData.checks.lowercase && (
            <i className={`bi ${strengthData.checks.lowercase ? 'bi-check-circle-fill text-success' : 'bi-circle'}`} style={{ fontSize: '0.7rem' }}></i>
          )}
          {strengthData.checks.uppercase && (
            <i className={`bi ${strengthData.checks.uppercase ? 'bi-check-circle-fill text-success' : 'bi-circle'}`} style={{ fontSize: '0.7rem' }}></i>
          )}
          {strengthData.checks.number && (
            <i className={`bi ${strengthData.checks.number ? 'bi-check-circle-fill text-success' : 'bi-circle'}`} style={{ fontSize: '0.7rem' }}></i>
          )}
          {strengthData.checks.special && (
            <i className={`bi ${strengthData.checks.special ? 'bi-check-circle-fill text-success' : 'bi-circle'}`} style={{ fontSize: '0.7rem' }}></i>
          )}
        </div>
      </div>
      {password.length > 0 && (
        <div className="strength-requirements mt-2">
          <small className="text-muted d-block">
            {!strengthData.checks.length && <span className="text-danger">• At least 8 characters</span>}
            {strengthData.checks.length && !strengthData.checks.lowercase && <span className="text-danger">• Lowercase letter</span>}
            {strengthData.checks.lowercase && !strengthData.checks.uppercase && <span className="text-danger">• Uppercase letter</span>}
            {strengthData.checks.uppercase && !strengthData.checks.number && <span className="text-danger">• Number</span>}
            {strengthData.checks.number && !strengthData.checks.special && <span className="text-danger">• Special character</span>}
          </small>
        </div>
      )}
    </div>
  );
}

export default PasswordStrengthIndicator;

